import { defineMessages } from 'react-intl';

export const fewResults = defineMessages({
  homes: {
    id: 'global_few_results_homes_title',
    defaultMessage: "We've found this homes you might be interested in",
    description: 'homes',
  },
  cars: {
    id: 'global_few_results_cars_title',
    defaultMessage: "We've found this cars you might be interested in",
    description: 'cars',
  },
  jobs: {
    id: 'global_few_results_jobs_title',
    defaultMessage: "We've found this job offers you might be interested in",
    description: 'jobs',
  },
  products: {
    id: 'global_few_results_products_title',
    defaultMessage: "We've found this products you might be interested in",
    description: 'jobs',
  },
});

export default defineMessages({
  alterQueryTitle: {
    id: 'global_alter_results_message',
    defaultMessage: 'Other ads you might also like',
  },
  moreAdsTitle: {
    id: 'global_more_ads_digest_decreaseprice',
    defaultMessage: 'More {%s} listings',
  },
});



// WEBPACK FOOTER //
// ./app/Serp/components/Lists/ListAds/messages.js